module.exports = __webpack_public_path__ + "media/images/nest_bkgnd-7a2bf9a9.png";